export default{
    msg:'',
    editar:{},
    lista:'',
    boletins:'',
    configuracaocartaoponto:''
}
